import React, { useContext, useState } from 'react';
import './index.scss';
import _ from 'lodash';
import { number, string, func } from 'prop-types';
import { useTranslation } from 'react-i18next';
import { DEFAULT_ERR } from '../../../../constants/defaults';
import { signUpPriceAlert } from '../../../../services/Api/DrugInfo';
import { validateMail } from '../../../../services/Api/User/UserService';
import { getLocationByZipCode } from '../../../../services/Api/SearchBar/SearchBarService';
import DialogCloseButton from '../../../common/Dialog/DialogCloseButton';
import Dialog from '../../../common/Dialog';
import loadable from '@loadable/component';
import { AuthContext } from '../../../../Contexts';
const AuthenticatedModal = loadable(() =>
  import('../../../HomeDeliveryNew/AuthenticateModal')
);

const PriceAlerts = props => {
  const userData = useContext(AuthContext)?.userData;
  const isLoggedIn = userData?.isLoggedIn;
  const [email, setEmail] = useState(userData?.email || '');
  const [zipCode, setZipCode] = useState(props.zipcodeValue);
  const [emailErrMessage, setEmailErrMessage] = useState('');
  const [zipCodeErrMessage, setZipCodeErrMessage] = useState('');
  const [apiStatus, setApiStatus] = useState(false);
  const [apiErrMessage, setApiErrMessage] = useState('');
  const [loading, setLoading] = useState(false);
  const [isSignupModalOpen, setIsignupModalOpen] = useState(false);

  const { t } = useTranslation();
  const closeButtonRef = React.useRef();

  const handleEmailBlur = e => {
    let value = e.target.value;
    if (_.isEmpty(value)) {
      setEmailErrMessage(t('This value is required.'));
      return;
    } else setEmailErrMessage('');
    !_.validateEmail(value)
      ? setEmailErrMessage(t('Please enter a valid email address.'))
      : setEmailErrMessage('');
  };

  const handleZipCodeBlur = e => {
    let value = e.target.value;
    if (_.isEmpty(value)) {
      setZipCodeErrMessage(t('This value is required.'));
      return;
    }
    validateZipCode(value);
  };

  const validateZipCode = zipCode => {
    if (_.isEmpty(zipCode)) {
      setZipCodeErrMessage(t('This value is required.'));
      return;
    }
    if (!_.isEmpty(zipCode) && zipCode.length < 5) {
      setZipCodeErrMessage(t('The location you entered is not valid.'));
    } else {
      getLocationByZipCode(zipCode)
        .then(res => {
          const locationSearchResults = res.status === 200 ? res : res.response;
          if (
            locationSearchResults &&
            locationSearchResults.status === 200 &&
            locationSearchResults.data !== null
          ) {
            setZipCodeErrMessage('');
            setZipCode(zipCode);
          } else {
            setZipCodeErrMessage('The location you entered is not valid.');
          }
        })
        .catch(() => {
          setZipCodeErrMessage(DEFAULT_ERR);
        });
    }
  };

  const handleSubmit = async e => {
    e.preventDefault();
    if (_.isEmpty(email)) {
      setEmailErrMessage(t('This value is required.'));
      return;
    }
    if (_.isEmpty(zipCode)) {
      setZipCodeErrMessage(t('This value is required.'));
      return;
    }
    if (zipCode?.length < 5) {
      setZipCodeErrMessage(t('The location you entered is not valid.'));
      return;
    }
    setLoading(true);
    const responseData = await validateMail(email);
    if (responseData && _.isEqual(responseData.result, 'undeliverable')) {
      setEmailErrMessage(t('Please enter a valid Email address.'));
      setLoading(false);
    } else {
      signUpPriceAlert(
        email,
        props.drugNdc,
        props.finalQty,
        zipCode,
        props.isCustomQuantity,
        isLoggedIn
      )
        .then(resp => {
          setLoading(false);
          resp.status === 200
            ? setApiStatus(true)
            : setApiErrMessage(
                resp.status === 409 ? resp.data.error : DEFAULT_ERR
              );
        })
        .catch(error => {
          console.log('error', error);
        });
    }
  };

  const handleZipCodeChange = async e => {
    let { value } = e.target;
    if (value.length > 5) value = value.slice(0, 5);
    setZipCode(value);
    validateZipCode(value);
  };

  const handleEmailChange = async e => {
    let { value } = e.target;
    setEmail(value);
    if (_.isEmpty(value)) {
      setEmailErrMessage(t('This value is required.'));
      return;
    } else setEmailErrMessage('');
  };

  const setFocusToCloseButton = event => {
    if (!_.isEmpty(event.relatedTarget)) {
      let relatedClassName = event.relatedTarget.className;
      if (relatedClassName.includes('dialogComponent')) {
        return;
      } else {
        closeButtonRef.current.focus();
      }
    }
  };

  return (
    <div>
      <div className="mainModal priceAlertsModal">
        <div
          className="transparentBg"
          onClick={() => props.hidepriceModal()}
        ></div>
        <Dialog
          className="modalContent"
          onBlur={e => setFocusToCloseButton(e)}
          escKeyFunction={props.hidepriceModal}
          isModalOpen={props.showPriceModal ? true : false}
        >
          <div className="commonForm">
            <h2 id="dialogTitleHeading">
              <span>Set price alert for:</span>
              <DialogCloseButton
                ref={closeButtonRef}
                className="closeModal"
                onClick={() => props.hidepriceModal()}
                img="icon-close-white.svg"
                alt=""
              />
            </h2>

            <div className="drugHeading">
              <div className="drugInfo">
                <span className="drugName">{props.drugName}</span>
                <span className="drugDetail">
                  {`${props.quantity} ${props.form}, ${props.selectedDosage}`}
                </span>
              </div>
            </div>
            <form autoComplete="on">
              {!apiStatus ? (
                <>
                  <div className="alertNote">
                    We’ll let you know when the price changes more than 10%
                    from&nbsp;<b>$</b>
                    {`${props.lowestPrice}`}
                  </div>
                  <div className="fullWidth form-group">
                    <label id="price-alert-email">{t('Email')}</label>
                    <div className="priceAlertInputWrapper">
                      <input
                        className={`themeFocus dialogComponent ${
                          !_.isEmpty(emailErrMessage) ? 'invalidInput' : ''
                        }`}
                        type="email"
                        name=""
                        placeholder="example@domain.com"
                        value={email}
                        onChange={e => handleEmailChange(e)}
                        onBlur={e => handleEmailBlur(e)}
                        autoFocus={true}
                        aria-labelledby="price-alert-email"
                        aria-required="true"
                        autoComplete="email"
                        aria-invalid={emailErrMessage ? 'true' : 'false'}
                        aria-describedby="invalidEmailErr"
                        disabled={apiStatus}
                      />
                      {!_.isEmpty(emailErrMessage) && (
                        <img
                          className="errorImage"
                          src="/content/images/icons/error.svg"
                          alt=""
                        />
                      )}
                    </div>
                    {!_.isEmpty(emailErrMessage) && (
                      <span
                        id="invalidEmailErr"
                        className="label-error"
                        role="alert"
                      >
                        {emailErrMessage}
                      </span>
                    )}
                  </div>
                  <div className="halfWidth form-group">
                    <label id="price-alert-zipcode">{t('Zip code')}</label>
                    <div className="priceAlertInputWrapper">
                      <input
                        placeholder="Enter zip"
                        type="number"
                        className={`themeFocus dialogComponent ${
                          !_.isEmpty(zipCodeErrMessage) ? 'invalidInput' : ''
                        }`}
                        value={zipCode}
                        onChange={e => handleZipCodeChange(e)}
                        onBlur={e => handleZipCodeBlur(e)}
                        tabIndex="0"
                        aria-labelledby="price-alert-zipcode"
                        aria-required="true"
                        autoComplete="postal-code"
                        aria-invalid={zipCodeErrMessage ? 'true' : 'false'}
                        aria-describedby="invalidZipcodeErr"
                        disabled={apiStatus}
                        inputMode="numeric"
                      />
                      {!_.isEmpty(zipCodeErrMessage) && (
                        <img
                          className="errorImage"
                          src="/content/images/icons/error.svg"
                          alt=""
                        />
                      )}
                    </div>
                    {!_.isEmpty(zipCodeErrMessage) && (
                      <span
                        id="invalidZipcodeErr"
                        className="label-error"
                        role="alert"
                      >
                        {zipCodeErrMessage}
                      </span>
                    )}
                  </div>
                  {loading ? (
                    <img
                      src="/content/images/loader/loading.gif"
                      alt="loader"
                      className="pdfLoader"
                      role="progressbar"
                    />
                  ) : (
                    <>
                      {!_.isEmpty(apiErrMessage) && (
                        <p className="label-error errorText">{apiErrMessage}</p>
                      )}
                      <button
                        className={`dialogComponent primaryButton themeFocus
                         ${
                           !_.isEmpty(zipCodeErrMessage) ||
                           !_.isEmpty(emailErrMessage) ||
                           !_.validateEmail(email)
                             ? 'disabled'
                             : ''
                         }`}
                        onClick={e => handleSubmit(e)}
                        disabled={
                          !_.isEmpty(zipCodeErrMessage) ||
                          !_.isEmpty(emailErrMessage)
                        }
                      >
                        Create price alert
                      </button>
                    </>
                  )}
                </>
              ) : (
                <>
                  <div className="priceSuccessLabel">
                    <img
                      src="/content/images/icons/priceAlertMark.svg"
                      alt=""
                    />
                    Price alert created!
                  </div>
                </>
              )}
            </form>
            {apiStatus && !props.userName && (
              <div className="setAlertAppPromo">
                <div className="titleLable">
                  <span>Members</span>&nbsp;save even more
                </div>
                <div className="appPromoContent">
                  <p className="desktop-only">
                    Sign up for a <span>free</span>&nbsp;SingleCare account to
                    unlock <br className="mobile-only" /> members-only prices.
                  </p>
                  <ul className="mobile-only">
                    <li>Free to join</li>
                    <li>
                      Extra&nbsp;<span>$3</span>&nbsp;off your first
                      prescription
                    </li>
                    <li>Unlock members-only pricing</li>
                  </ul>
                  <button
                    className="signupBtn"
                    onClick={() => setIsignupModalOpen(true)}
                  >
                    Sign up now
                  </button>
                </div>
              </div>
            )}
          </div>
        </Dialog>
      </div>
      {isSignupModalOpen && (
        <div className="mainModal afterSignupmodal">
          <div
            className="transparentBg"
            onClick={() => setIsignupModalOpen(!isSignupModalOpen)}
          ></div>
          <div className="signUpModal">
            <AuthenticatedModal
              hideAuthenticateModal={() => {
                setIsignupModalOpen(false);
                props.hidepriceModal();
              }}
            />
          </div>
        </div>
      )}
    </div>
  );
};

PriceAlerts.propTypes = {
  drugNdc: string,
  hidepriceModal: func,
  drugName: string,
  selectedDosage: string,
  quantity: number,
  form: string,
  lowestPrice: string,
  zipcodeValue: string,
  finalQty: number
};

PriceAlerts.defaultProps = {
  drugNdc: '',
  hidepriceModal: () => {},
  drugName: '',
  selectedDosage: '',
  quantity: 0,
  form: '',
  lowestPrice: '',
  zipcodeValue: '',
  finalQty: 0
};

export default PriceAlerts;
